<template>
    <div class="row">
        <div class="col-md-6">
            <h4>Discount<sup>* Press <strong class="text-success">enter</strong> to add
                discount</sup></h4>
        </div>
        <div class="col-md-6 text-right">
            <el-radio-group v-model="selectedModel" size="mini">
                <el-radio-button v-for="(type, index) in types"
                                 :label="type"
                                 :key="index"/>
            </el-radio-group>
        </div>
        <div class="col-md-12">
            <el-input v-if="typeSelected === 'Fixed'"
                      v-model.number.trim="fixedValueModel"
                      @keyup.enter.native="$emit('applyFixed')"
                      v-mask="fixedMask"
                      :disabled="disabled"
                      type="text"
                      placeholder="Fixed Discount">
                <span v-text="fixedValue"></span>
            </el-input>
            <el-input v-else-if="typeSelected === 'Percent'"
                      v-model.number.trim="percentValueModel"
                      @keyup.enter.native="$emit('applyPercent')"
                      v-mask="percentMask"
                      :disabled="disabled"
                      type="text"
                      placeholder="Percent Discount">
                <span v-text="percentValue"></span>
            </el-input>
            <el-input v-else
                      v-model.trim="discountCodeModel"
                      @keyup.enter.native="$emit('applyDiscountCode')"
                      :disabled="disabled"
                      type="text"
                      placeholder="Discount Code">
                <span v-text="discountCode"></span>
            </el-input>
        </div>
    </div>
</template>

<script>
  import {mask} from '../../../directives';

  export default {
    name: 'OrderAddDiscountCode',
    directives: {
      mask,
    },
    props: {
      disabled: {
        default: false,
      },
      typeSelected: {
        required: true,
      },
      discountCode: {
        required: true,
      },
      fixedValue: {
        required: true,
      },
      percentValue: {
        required: true,
      },
    },
    computed: {
      selectedModel: {
        get() {
          return this.typeSelected;
        },
        set(value) {
          this.$emit('update:typeSelected', value);
        },
      },
      discountCodeModel: {
        get() {
          return this.discountCode;
        },
        set(value) {
          this.$emit('update:discountCode', value);
        },
      },
      fixedValueModel: {
        get() {
          return this.fixedValue;
        },
        set(value) {
          this.$emit('update:fixedValue', value);
        },
      },
      percentValueModel: {
        get() {
          return this.percentValue;
        },
        set(value) {
          this.$emit('update:percentValue', value);
        },
      },
    },
    data() {
      return {
        types: ['Code', 'Fixed', 'Percent'],
        fixedMask: {
          alias: 'currency',
          prefix: '$',
          rightAlign: false,
          showMaskOnHover: false,
          autoUnmask: true,
          clearIncomplete: true,
        },
        percentMask: {
          alias: 'percentage',
          suffix: '%',
          rightAlign: false,
          showMaskOnHover: false,
          autoUnmask: true,
          clearIncomplete: true,
        },
      };
    },
  };
</script>

